import { render, staticRenderFns } from "./buildingInfo.vue?vue&type=template&id=b0d65b12&scoped=true"
import script from "./buildingInfo.vue?vue&type=script&lang=js"
export * from "./buildingInfo.vue?vue&type=script&lang=js"
import style0 from "./buildingInfo.vue?vue&type=style&index=0&id=b0d65b12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d65b12",
  null
  
)

export default component.exports